module.exports = __webpack_public_path__ + "static/media/skating-night.0a4964f3.jpg";